import React from 'react';

const DASH_PATTERNS = {
  dashed: '6 4',
  dotted: '2 3',
  solid: null,
};

/**
 * Renders one preset as SVG at the shape's real pixel size.
 *
 * The viewBox matches the element's measured box exactly, so there is no
 * scaling anywhere in the pipeline. That is what keeps strokes uniform under a
 * non-uniform resize; the old code stretched a 0 0 100 100 box with
 * preserveAspectRatio="none" and distorted every stroke with it. The path is
 * built inside a box inset by half the stroke width so the stroke never renders
 * outside the viewport and clips.
 */
const ShapeGeometry = ({ shapeId, preset, adjustments, size, properties }) => {
  const { width, height } = size;
  if (width <= 0 || height <= 0) return null;

  const {
    isTransparent = false,
    strokeWidth = 1,
    backgroundColor = '#ffffff',
    borderColor = '#000000',
    opacity = 100,
    borderStyle = 'solid',
  } = properties;

  const stroke = Math.max(0, Number(strokeWidth) || 0);
  const inset = stroke / 2;
  const box = {
    x: inset,
    y: inset,
    width: Math.max(0, width - stroke),
    height: Math.max(0, height - stroke),
  };

  return (
    <svg
      width="100%"
      height="100%"
      viewBox={`0 0 ${width} ${height}`}
      id={shapeId}
      style={{ opacity: opacity / 100, display: 'block', overflow: 'visible' }}
    >
      <path
        id={shapeId}
        d={preset.path(box, adjustments)}
        fill={isTransparent ? 'none' : backgroundColor}
        stroke={borderColor}
        strokeWidth={stroke}
        strokeDasharray={DASH_PATTERNS[borderStyle] || undefined}
      />
    </svg>
  );
};

export default ShapeGeometry;
